var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#D14545"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34091 16.4791C8.12624 16.4786 7.92248 16.4003 7.76295 16.2482C7.60712 16.0924 7.52522 15.8923 7.52841 15.6813C7.53159 15.463 7.61254 15.2633 7.76393 15.1119L10.9136 11.977L7.80442 8.84565C7.64859 8.68982 7.58514 8.47129 7.57358 8.2825C7.5842 8.07895 7.65771 7.86445 7.8091 7.71306C7.96049 7.56167 8.16386 7.47703 8.37854 7.47754C8.59322 7.47806 8.8044 7.56369 8.95652 7.71581L12.0583 10.8472L15.1453 7.78248C15.293 7.63478 15.5 7.54645 15.7147 7.54696C15.9294 7.54748 16.1258 7.64048 16.2779 7.7926C16.5896 8.10426 16.5945 8.61135 16.2806 8.92521L13.19 11.9936L16.2733 15.136C16.5554 15.4698 16.5381 15.9546 16.239 16.2463C15.9399 16.538 15.4624 16.548 15.1435 16.2733L12.0231 13.1308L8.91035 16.2435C8.75896 16.3949 8.5519 16.4833 8.33722 16.4828L8.34091 16.4791Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/redCross.746031a96b8099a2f9b2544dfc99d6ee.svg";
export { ForwardRef as ReactComponent };